import { createContext } from "react";
const ExpandableGroupContext = createContext({
  activeNode: null,
  setActiveNode: () => {
  }
});
export {
  ExpandableGroupContext
};
